import { useForm } from "react-hook-form";
import { Form, FormItem, FormRow, FormError } from "@/components/form";
import { Flex } from "@/components/flex";
import { Button } from "@/components/button";
import { Loader } from "@/components/loader";
import { IObject } from "@/models/types";
import { useAppDispatch, useAppSelector } from "src/config/store";
import { createObject, editObject } from "@/reducers/object-crud.reducer";
import ModalHeader from "@/components/modal/modal-header";
import ModalBody from "@/components/modal/modal-body";
import { validationSchema } from "src/utils/validation-utils";

type Props = {
  object: IObject;
};

const ObjectEdit = (props: Props) => {
  const { object } = props;

  const isEdit = object.ID ? true : false;
  const dispatch = useAppDispatch();
  const objectsCrudState = useAppSelector((state) => state.objectsCrud);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange", defaultValues: object });

  const save = (data) => {
    isEdit ? dispatch(editObject(data)) : dispatch(createObject(data));
  };

  return (
    <>
      <ModalHeader />
      <ModalBody>
        <Form>
          <FormRow>
            <FormItem name="post_title" label={"Nome"}>
              <input
                id="post_title"
                placeholder={"Nome"}
                {...register("post_title", validationSchema.required)}
              />

              {errors.post_title && <FormError error={errors.post_title.message} />}
            </FormItem>
          </FormRow>

          <FormRow>
            <FormItem>
              <Flex container alignItems="center">
                <Button
                  className="ml-auto"
                  size="md"
                  color="primary"
                  disabled={!isValid || objectsCrudState.loading}
                  onClick={handleSubmit(save)}
                >
                  {objectsCrudState.loading ? <Loader /> : "Salva"}
                </Button>
              </Flex>
            </FormItem>
          </FormRow>
        </Form>
      </ModalBody>
    </>
  );
};

export default ObjectEdit;
